'use strict';

function EditData() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.declaredClass = null;

  this.init = function () {
    $('.js-formEditSection').hide();
    this.$node = $(this.node);
  };

  this.initAllReady = function () {};

  // @TODO cleanup method and traversal
  this.onEditSection = function (callback, event) {
    var $target = $(event.target);
    if (!$target.hasClass('editData__edit-icon--disabled')) {
      this.$node.find('.js-editData__summary').slideUp();
      this.$node.find('.js-formEditSection').slideDown();

      $target.addClass('editData__edit-icon--disabled');
    }
    if (callback) callback();
  };

  this.closeSection = function (callback) {
    $('.js-editData__edit-icon').removeClass('editData__edit-icon--disabled');
    $('.js-editData__summary', this.node).slideDown();
    $('.js-formEditSection', this.node).slideUp(callback);
  };

  this.cancelEdits = function (model, callback) {
    this.presenter.resetModels(model);
    this.closeSection(this._reRunValidation);
    if (callback) callback();
  };

  this._reRunValidation = function () {
    var errorArray = [];
    $('.error', this).each(function () {
      var name = $(this).attr('name');
      if (name) errorArray.push(name);
    });
    if (errorArray.length && $('form', this).mogo().runPartialValidation) $('form', this).mogo().runPartialValidation(errorArray);
  };

  this.destroy = function () {};
}